import { combineReducers } from 'redux';
import activityReducer from './redux/reducers/activityReducer';
import sessionReducer from './redux/reducers/sessionReducer';
import alexReducer from './redux/reducers/alexReducer';

export default combineReducers({
  activityReducer,
  sessionReducer,
  alexReducer,
});
